import Devices from './modules/devices/index';
import Fullscreen from './modules/fullscreen/index';
import Market from './modules/market/index';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { Devices, Fullscreen, Market }
});
